import styled from "styled-components";

export const RightContainer = styled.div`
    display: flex;
    /* align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: #f7f8f9; */
    flex: 1;
`;
export const FirstStep = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    & > p {
        color: #1e2228;
        text-align: center;
        /* font-family: Inter; */
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px; /* 150% */
    }
    & > button {
        padding: 12px 22px;
        color: var(--BLue, #1b49ea);
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        border-radius: 8px;
        border: 1px solid #1b49ea;
        background: #fff;

        &:hover {
            color: white;
            background-color: #1b49ea;
        }
    }
`;
export const SecondStep = styled.div`
    flex: 1;
    border-radius: 8px;
    /* margin-left:15%; */
    overflow: scroll;
    background-color:#f7f8f9;
    height: 100vh;
    box-shadow: 0px 2px 4px 0px rgba(30, 34, 40, 0.03);
    /* padding: 40px 30px; */
    padding: 36px;
`;
export const Table = styled.table`
    width: 100%;
`;
export const Heading = styled.p`
    color: #1e2228;
    /* font-family: Inter; */
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;
export const Wrapper = styled.div`
    padding: 20px 30px;
    background-color: white;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    color: #1e2228;
    /* font-family: Inter; */
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    & > div {
        display: flex;
        flex-direction: row;
        width: 100%;
        padding: 30px;
    }
`;
export const Div1 = styled.div`
    display: flex;
    /* flex: 1; */
    width: 40%;
    flex-direction: column;
    & > span {
        margin-bottom: 15px;
    }
`;
export const Div2 = styled.div`
    display: flex;
    flex: 1;
    width: 15%;
    justify-content: center;
`;
export const Div3 = styled.div`
    display: flex;
    flex: 1;
    width: 15%;
    justify-content: center;
`;
export const Div4 = styled.div`
    display: flex;
    flex: 1;
    width: 15%;
    justify-content: center;
    color: ${(props) => (!props.heading ? "#FF2C91" : "black")};
`;
export const Div5 = styled.div`
    display: flex;
    flex: 1;
    width: 15%;
    & > span {
        background-color: #edf0fd;
        width: 32px;
        height: 32px;

        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        cursor: pointer;
        &:hover {
            background-color: #1b49ea;
        }
        &:last-child {
            margin-right: 0;
        }
        & > img {
            height: 18px;
            width: 18px;
            /* z-index: 1000; */
        }
    }
`;
export const Icons = styled.div`
    display: flex;
    justify-content: space-between;
    & > span {
        color: #1e2228;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        & > img {
            margin-right: 10px;
        }
    }
`;
export const ListContainer = styled.div`
    border: 1px solid #efeff0;

    /* border-radius: 0px; */
    display: flex;
    align-items: center;
    padding: 30px;

    border-top-right-radius: ${(props) => (props.index === 0 ? "8px" : "0px")};
    border-top-left-radius: ${(props) => (props.index === 0 ? "8px" : "0px")};

    &:last-child {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
    }
`;
export const FirstStepWrapper = styled.div`
    width: 100%;
    background-color: #f7f8f9;
    padding: 36px;
    height: 100vh;

    & > p {
        margin-top: 70px;
        color: #1e2228;
        /* font-family: Inter; */
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }
    & > div {
        border-radius: 8px;
        background: #fff;

        box-shadow: 0px 2px 4px 0px rgba(30, 34, 40, 0.03);
    }
`;
export const AddNewContainer = styled.div`
    margin-top: 35px;
`;
export const FooterText = styled.div`
    color: #939599;
    text-align: right;
    /* font-family: Inter; */
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 15px;
    background-color: #f7f8f9 !important;
    border: none !important;
    border-radius: 0px !important;
    box-shadow: none !important;
`;
